import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabbookinginhyderabad() {



  const cardData =
  {
    keyword: 'Corporate Cab Bookings in Hyderabad',
    heading: 'Aaryan Travels: Corporate Cab Bookings in Hyderabad',
    headingDescription: 'Aaryan Travels provides professional Corporate Cab Bookings in Hyderabad for IT companies, business travelers, and corporate executives requiring reliable transportation across the city. Whether it is daily office commutes, airport pickups from Rajiv Gandhi International Airport, client transfers to HITEC City, or intercity travel to Bangalore and Vijayawada, our fleet of sedans, SUVs, and tempo travellers ensures punctuality and comfort. With trained chauffeurs, GPS-enabled vehicles, monthly billing options, and 24/7 availability, we offer seamless corporate mobility across Gachibowli, Banjara Hills, Kukatpally, and Jubilee Hills. Aaryan Travels is your trusted partner for dependable corporate cab booking services in Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, built in 1591 by Sultan Muhammad Quli Qutb Shah, is the most iconic symbol of Hyderabad. Its four grand minarets and Indo-Islamic architecture attract thousands of visitors daily. Surrounded by bustling bazaars like Laad Bazaar, it is a hub for bangles, pearls, and street food. Illuminated at night, it offers a stunning view. Charminar is Hyderabad’s timeless monument of culture and heritage."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic hilltop fortress known for its incredible acoustics and royal history. It was once the center of the diamond trade, home to the famous Kohinoor diamond. Visitors explore massive gateways, royal chambers, and scenic viewpoints. The evening sound-and-light show brings the fort’s past to life. Golconda Fort is Hyderabad’s grand legacy of strength and splendor."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City holds the Guinness World Record as the largest film studio complex in the world. It offers guided tours of movie sets, live performances, adventure rides, and themed attractions. From palaces to airports, it recreates multiple cinematic worlds. Families enjoy a full day of entertainment. Ramoji Film City is Hyderabad’s ultimate destination of fun and fantasy."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped lake connecting Hyderabad and Secunderabad. At its center stands a 58-foot monolithic Buddha statue on a rock island. Boat rides at sunset offer breathtaking skyline views. The Necklace Road around the lake is perfect for evening strolls and street snacks. Hussain Sagar is Hyderabad’s peaceful retreat by the water."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, housing global collections amassed by Mir Yousuf Ali Khan, Salar Jung III. Highlights include the Veiled Rebecca statue and the famous musical clock. The galleries feature paintings, weapons, furniture, and rare artifacts. Every corridor tells a story. Salar Jung Museum is Hyderabad’s treasure of world heritage."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a stunning marble temple dedicated to Lord Venkateswara, located atop Naubat Pahad hill. It offers panoramic views of the city and Hussain Sagar Lake. The intricate carvings and peaceful ambiance draw devotees and tourists alike. Illuminated at night, it looks divine. Birla Mandir is Hyderabad’s shining beacon of devotion."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the royal residence of the Nizams, showcasing grand durbar halls, vintage cars, and lush courtyards. The Khilwat Mubarak hall with its chandeliers is the most striking feature. Cultural events and photoshoots often take place here. Chowmahalla Palace is Hyderabad’s royal display of elegance and legacy."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, one of the oldest and largest mosques in India, was built using soil brought from Mecca. Its massive arches, domes, and spacious courtyard reflect architectural brilliance. Thousands gather here for Friday prayers. Pigeons fluttering around add to the peaceful ambiance. Mecca Masjid is Hyderabad’s sacred sanctuary of faith."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is famous for its lacquer bangles, pearls, and bridal accessories. The narrow lanes filled with colorful shops and traditional stalls offer a lively shopping experience. Bargaining is part of the fun here. Laad Bazaar is Hyderabad’s vibrant marketplace of tradition and glamour."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s largest zoos, home to tigers, lions, bears, and exotic birds. Safari rides and toy trains add adventure for children and families. The park’s lush greenery and water bodies make it an ideal day outing. Nehru Zoo is Hyderabad’s wild escape into nature."
  }
],



  "services": [
  {
    "name": "Corporate Cab Bookings in Hyderabad",
    "description": "Corporate Cab Bookings in Hyderabad offer reliable and efficient transportation solutions tailored for businesses. With professional chauffeurs and timely service, companies can manage employee and client travel smoothly."
  },
  {
    "name": "Business Taxi Services Hyderabad",
    "description": "Business Taxi Services Hyderabad provide prompt and comfortable taxi options designed specifically for corporate needs, including meetings, events, and executive travel."
  },
  {
    "name": "Corporate Transport Hyderabad",
    "description": "Corporate Transport Hyderabad offers comprehensive transport management for companies, including staff commuting and client visits with flexible scheduling and professional drivers."
  },
  {
    "name": "Office Cab Hire Hyderabad",
    "description": "Office Cab Hire Hyderabad helps businesses arrange daily employee commutes with fixed routes and schedules, ensuring safety, punctuality, and convenience."
  },
  {
    "name": "Staff Cab Hyderabad",
    "description": "Staff Cab Hyderabad delivers dependable daily transport services for company staff, with route optimization and reliable drivers to ensure timely arrivals."
  },
  {
    "name": "Monthly Corporate Cab Hyderabad",
    "description": "Monthly Corporate Cab Hyderabad provides cost-effective monthly plans for recurring corporate travel needs, ideal for regular office commutes and business trips."
  },
  {
    "name": "Chauffeur Driven Cab Hyderabad",
    "description": "Chauffeur Driven Cab Hyderabad features professional drivers offering executive-class cab services for senior management and VIP clients, ensuring comfort and professionalism."
  },
  {
    "name": "Book Corporate Taxi Hyderabad",
    "description": "Book Corporate Taxi Hyderabad offers an easy online booking platform for businesses to schedule and manage corporate taxi services efficiently."
  },
  {
    "name": "Affordable Corporate Cab Hyderabad",
    "description": "Affordable Corporate Cab Hyderabad combines quality service with budget-friendly pricing, catering to startups and SMEs requiring reliable transport solutions."
  },
  {
    "name": "Executive Cab Services Hyderabad",
    "description": "Executive Cab Services Hyderabad focus on premium transportation for business leaders, featuring luxury vehicles and discreet, courteous chauffeurs."
  },
  {
    "name": "Corporate Vehicle Hire Hyderabad",
    "description": "Corporate Vehicle Hire Hyderabad offers flexible rental options for sedans, SUVs, and luxury cars tailored to business requirements, complete with professional drivers."
  },
  {
    "name": "Hyderabad Business Cab Booking",
    "description": "Hyderabad Business Cab Booking enables companies to easily book business-class cabs for meetings, client visits, and employee travel with reliable support."
  },
  {
    "name": "Reliable Corporate Taxi Hyderabad",
    "description": "Reliable Corporate Taxi Hyderabad emphasizes consistent service quality, punctuality, and professionalism for daily corporate transport needs."
  },
  {
    "name": "Corporate Car Rental Hyderabad",
    "description": "Corporate Car Rental Hyderabad provides monthly and long-term rental options for a range of corporate vehicles, allowing flexible and efficient business mobility."
  },
  {
    "name": "Corporate Chauffeur Hyderabad",
    "description": "Corporate Chauffeur Hyderabad offers premium chauffeur-driven services for executives and corporate events, with drivers trained in etiquette and discretion."
  }
],
"tableData": [
  ["Corporate Cab Bookings in Hyderabad", "Business Taxi Services Hyderabad"],
  ["Corporate Transport Hyderabad", "Office Cab Hire Hyderabad"],
  ["Staff Cab Hyderabad", "Monthly Corporate Cab Hyderabad"],
  ["Chauffeur Driven Cab Hyderabad", "Book Corporate Taxi Hyderabad"],
  ["Affordable Corporate Cab Hyderabad", "Executive Cab Services Hyderabad"],
  ["Corporate Vehicle Hire Hyderabad", "Hyderabad Business Cab Booking"],
  ["Reliable Corporate Taxi Hyderabad", "Corporate Car Rental Hyderabad"],
  ["Corporate Chauffeur Hyderabad", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Bookings in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels provides reliable corporate cab bookings in Hyderabad, tailored to meet your business travel demands."
  },
  {
    "WhyChooseheading": "Professional and Punctual Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs, helping your corporate operations run smoothly."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Fleet",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned vehicles maintained for your comfort and safety during corporate journeys."
  },
  {
    "WhyChooseheading": "Drivers Well-Acquainted with Hyderabad Routes",
    "WhyChoosedescription": "Our drivers have in-depth knowledge of Hyderabad’s roads, ensuring efficient and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from fixed pricing inclusive of fuel, tolls, and driver allowances for straightforward billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available anytime to assist with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible and Customizable Plans",
    "WhyChoosedescription": "Choose plans tailored to your company’s travel needs and vehicle preferences."
  },
  {
    "WhyChooseheading": "Exclusive Fleet Dedicated to Corporate Clients",
    "WhyChoosedescription": "Enjoy priority service with vehicles reserved exclusively for your organization’s travel requirements."
  }
]



















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab bookings in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides dependable corporate cab booking services in Hyderabad tailored to your business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Hyderabad with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team in Hyderabad.',
  },
  {
    question: 'What types of vehicles are available for corporate cab bookings in Hyderabad?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and premium cars suited for corporate travel in Hyderabad.',
  },
  {
    question: 'Are drivers experienced and trained for corporate cab bookings in Hyderabad?',
    answer: 'Absolutely. Our drivers in Hyderabad are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate bookings in Hyderabad?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Hyderabad and nearby business areas.',
  },
  {
    question: 'Is the corporate cab booking service available 24x7 in Hyderabad?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab booking services to meet your business schedules in Hyderabad.',
  },
  {
    question: 'Are safety and hygiene protocols followed for corporate cab bookings in Hyderabad?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for corporate cab bookings in Hyderabad?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the corporate cab booking period in Hyderabad?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your booking period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanjay Reddy',
    feedback: 'Aaryan Travels provided excellent corporate cab booking services in Hyderabad with professional drivers and timely service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Sharma',
    feedback: 'Reliable and efficient corporate cab bookings by Aaryan Travels in Hyderabad. Highly recommend for business travel!',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const corporateCabHyderabadSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Bookings in Hyderabad",
  "description": "Aaryan Travels offers reliable corporate cab bookings in Hyderabad with chauffeur-driven vehicles for business travel, office transport, and staff cab services.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "serviceType": "Corporate Cab Bookings",
  "keywords": "Corporate Cab Bookings in Hyderabad, Business Taxi Services Hyderabad, Corporate Transport Hyderabad, Office Cab Hire Hyderabad, Staff Cab Hyderabad, Monthly Corporate Cab Hyderabad, Chauffeur Driven Cab Hyderabad, Book Corporate Taxi Hyderabad, Affordable Corporate Cab Hyderabad, Executive Cab Services Hyderabad, Corporate Vehicle Hire Hyderabad, Hyderabad Business Cab Booking, Reliable Corporate Taxi Hyderabad, Corporate Car Rental Hyderabad, Corporate Chauffeur Hyderabad"
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Bookings in Hyderabad | Reliable Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book corporate cab services in Hyderabad with Aaryan Travels. Affordable chauffeur-driven cabs for office transport, staff cabs, and business travel."
  />
  <meta
    name="keywords"
    content="Corporate Cab Bookings in Hyderabad, Business Taxi Services Hyderabad, Corporate Transport Hyderabad, Office Cab Hire Hyderabad, Staff Cab Hyderabad, Monthly Corporate Cab Hyderabad, Chauffeur Driven Cab Hyderabad, Book Corporate Taxi Hyderabad, Affordable Corporate Cab Hyderabad, Executive Cab Services Hyderabad, Corporate Vehicle Hire Hyderabad, Hyderabad Business Cab Booking, Reliable Corporate Taxi Hyderabad, Corporate Car Rental Hyderabad, Corporate Chauffeur Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateCabHyderabadSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabbookinginhyderabad;